import React from 'react';
import { SelectInput } from '@lightbeamhealth/blueprint-form';
import { useApps } from '../../../../contexts/apps';
import { AppsData } from '../../../../contexts/apps/types';
import { SimpleApp } from '../../../../libs/apps';

interface FormSelectAppProps {
  large?: boolean;
  label?: string;
  selectAllLabel?: string;
  name?: string;
  required?: boolean;
  fill?: boolean;
}

const createOptions = (apps: AppsData['apps'], selectAllLabel: string) => {
  if (!apps) {
    return [];
  }
  const options = [{ label: selectAllLabel, value: '' }];
  const programs = Object.entries(apps).sort((a, b) => {
    const aKey = a[0];
    const bKey = b[0];
    if (aKey < bKey) {
      return -1;
    }
    if (bKey < aKey) {
      return 1;
    }
    return 0;
  });
  for (const [appKey, appValue] of programs) {
    // Skip 'composer' app since that is only needed for
    // enrollments. We use the schema-based program app key here
    // to select schema-based programs.
    if (appKey === 'composer') {
      continue;
    }
    const app: SimpleApp = appValue;
    options.push({
      label: app.name,
      value: appKey
    });
  }
  return options;
};

const FormSelectApp = ({
  large,
  label = 'Programs',
  selectAllLabel = 'Select One',
  name = 'app',
  required = false,
  fill = false
}: FormSelectAppProps): JSX.Element => {
  const { data } = useApps();
  const apps = data ? data.apps : null;
  const options = createOptions(apps, selectAllLabel);
  return (
    <SelectInput
      label={label}
      name={name}
      large={large}
      required={required}
      fill={fill}
      options={options}
    />
  );
};

export default FormSelectApp;
